"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var lodash_1 = require("lodash");
var classNames = require("classnames");
var react_router_1 = require("react-router");
var affirm_banner_1 = require("./affirm_banner");
var sale_information_1 = require("./sales/sale_information");
var collection_header_edit_button_1 = require("./collection_header_edit_button");
var collection_header_rename_button_1 = require("./collection_header_rename_button");
var collection_header_store_1 = require("./stores/collection_header_store");
var user_store_1 = require("../../reverb-js-common/user_store");
var USA = 'US';
var CollectionHeaderComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionHeaderComponent, _super);
    function CollectionHeaderComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = collection_header_store_1.CollectionHeaderStore.getState();
        _this.onCollectionHeaderStoreUpdated = _this.onCollectionHeaderStoreUpdated.bind(_this);
        return _this;
    }
    CollectionHeaderComponent.prototype.componentDidMount = function () {
        collection_header_store_1.CollectionHeaderStore.listen(this.onCollectionHeaderStoreUpdated);
    };
    CollectionHeaderComponent.prototype.componentWillUnmount = function () {
        collection_header_store_1.CollectionHeaderStore.unlisten(this.onCollectionHeaderStoreUpdated);
    };
    CollectionHeaderComponent.prototype.onCollectionHeaderStoreUpdated = function () {
        this.setState(collection_header_store_1.CollectionHeaderStore.getState());
    };
    Object.defineProperty(CollectionHeaderComponent.prototype, "fullBleedImage", {
        get: function () {
            return lodash_1.get(this.state, 'collectionHeader._links.full_bleed_header_image.href');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "headerImage", {
        get: function () {
            return lodash_1.get(this.state, 'collectionHeader._links.header_image.href');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "backgroundImage", {
        get: function () {
            if (!this.fullBleedImage)
                return null;
            return { style: { backgroundImage: "url('" + this.fullBleedImage + "')" } };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "isLoaded", {
        get: function () {
            return !lodash_1.isEmpty(this.state.collectionHeader);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "isSale", {
        get: function () {
            return !!this.state.collectionHeader.sale;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "isAffirmPromotion", {
        get: function () {
            return !!this.props.affirmPromotionMonths || !!this.state.collectionHeader.affirm_promotion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "affirmPromotion", {
        get: function () {
            if (!this.isAffirmPromotion) {
                return null;
            }
            return this.state.collectionHeader.affirm_promotion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "affirmPromotionMonths", {
        get: function () {
            return this.props.affirmPromotionMonths || this.affirmPromotion.months;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "isBrandPage", {
        get: function () {
            if (this.props.params) {
                return !!this.props.params.brand_slug;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "adminButtonSlug", {
        get: function () {
            if (this.isBrandPage) {
                return lodash_1.get(this.props, 'params.brand_slug');
            }
            return lodash_1.get(this.props, 'params.curated_set_slug');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderComponent.prototype, "title", {
        get: function () {
            return this.props.titleOverride ||
                lodash_1.get(this.state, 'collectionHeader.title');
        },
        enumerable: true,
        configurable: true
    });
    CollectionHeaderComponent.prototype.hasDescription = function () {
        return !!this.state.collectionHeader.description;
    };
    CollectionHeaderComponent.prototype.renderHeaderImage = function () {
        if (this.props.hideBanner || !this.headerImage) {
            return null;
        }
        return (React.createElement("div", { className: "collection-header__title__banner" },
            React.createElement("img", { role: "presentation", src: this.headerImage })));
    };
    CollectionHeaderComponent.prototype.renderFineprint = function () {
        if (!this.isSale) {
            return null;
        }
        var descriptionHTML = lodash_1.get(this.state, 'collectionHeader.description');
        return (React.createElement(sale_information_1.default, { sale: this.state.collectionHeader.sale, description: descriptionHTML, socialLinks: lodash_1.get(this.state, 'collectionHeader._links.social'), location: this.props.location }));
    };
    CollectionHeaderComponent.prototype.renderHeaderButtons = function () {
        return (React.createElement("div", { className: "collection-header__buttons" },
            this.renderHeaderEditButton(),
            this.renderHeaderRenameButton()));
    };
    CollectionHeaderComponent.prototype.renderHeaderEditButton = function () {
        return (React.createElement(collection_header_edit_button_1.default, { isSale: this.isSale, slug: this.adminButtonSlug, isBrandPage: this.isBrandPage }));
    };
    CollectionHeaderComponent.prototype.renderHeaderRenameButton = function () {
        if (!this.isBrandPage) {
            return null;
        }
        return (React.createElement(collection_header_rename_button_1.default, { slug: this.adminButtonSlug }));
    };
    CollectionHeaderComponent.prototype.renderAffirmBanner = function () {
        var shouldShowBanner = this.isAffirmPromotion && user_store_1.default.getState().countryCode === USA;
        if (!shouldShowBanner) {
            return null;
        }
        return (React.createElement(affirm_banner_1.default, { months: this.affirmPromotionMonths }));
    };
    CollectionHeaderComponent.prototype.renderHeader = function () {
        if (this.props.headerLinkTarget) {
            return (React.createElement("h1", { className: "collection-header__title__text" },
                React.createElement(react_router_1.Link, { to: this.props.headerLinkTarget, className: "collection-header__title__link" }, this.title)));
        }
        return (React.createElement("h1", { className: "collection-header__title__text" }, this.title));
    };
    CollectionHeaderComponent.prototype.renderSubtitle = function () {
        if (!this.props.subtitle) {
            return null;
        }
        return (React.createElement("h2", { className: "collection-header__subtitle" }, this.props.subtitle));
    };
    CollectionHeaderComponent.prototype.render = function () {
        if (!this.isLoaded) {
            return null;
        }
        var classes = classNames('collection-header', { 'collection-header--with-subtitle': this.props.subtitle }, { 'collection-header--with-image': !!this.fullBleedImage }, { 'collection-header--with-description': this.hasDescription() });
        return (React.createElement("div", { className: classes },
            React.createElement("header", tslib_1.__assign({ className: "collection-header__title" }, this.backgroundImage),
                this.renderHeaderImage(),
                this.renderHeader(),
                this.renderSubtitle()),
            this.renderAffirmBanner(),
            this.renderFineprint(),
            this.renderHeaderButtons()));
    };
    return CollectionHeaderComponent;
}(React.Component));
CollectionHeaderComponent.propTypes = {
    params: PropTypes.object,
    hideBanner: PropTypes.bool,
    titleOverride: PropTypes.string,
    subtitle: PropTypes.string,
    headerLinkTarget: PropTypes.string,
    location: PropTypes.object,
    affirmPromotionMonths: PropTypes.array,
};
CollectionHeaderComponent.defaultProps = {
    hideBanner: false,
};
exports.default = CollectionHeaderComponent;
//# sourceMappingURL=collection_header_component.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/collection_header_component.js
// module id = eMFt
// module chunks = 20 21